// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if showLabel}}
    <terceraLabel text="{{label}}" />
    {{/if}}

    <div class="oe-selector-right">
        <terceraComboBox showLastValue="true"
                         items="{{items}}"
                         selectedItem="{{selectedItem}}"
                         name="combobox"
                         visibleInfoBtn="{{visibleInfoBtn}}"
                         infoBtnTooltip="{{infoBtnTooltip}}" />
    </div>
</div>`;
// Exports
export default code;